<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M36 24H12"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
